export enum UserRole {
  AppUser = 'AppUser',
}
